import React from 'react';
import styled from 'styled-components';
import { default as ErrorIconSVG } from 'packages/smart-home-support/components/ErrorIcon';
import { FieldError, FieldWrapperProps } from './models';

const s = {
  InputWrapper: styled.div`
    position: relative;
  `,
  Label: styled.label`
    display: block;
    margin-top: 10px;
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 12px;
    color: #1b1b1b;
  `,
  Help: styled.div`
    height: 20px;
    font-size: 12px;
    margin-top: 8px;
  `,
  HelpMessage: styled.span`
    color: #6c747b;
  `,
  FieldErrorMessage: styled.div<{ visible: boolean }>`
    color: ${(props) => props.theme.colors.error};
    font-weight: 500;
    opacity: ${(props) => (props.visible ? 1 : 0)};
    transition: opacity 0.2s;
  `,
  ErrorIcon: styled.div<{ visible: boolean }>`
    transition: opacity 0.2s;
    margin-right: 13px;
    display: flex;
    justify-content: center;
    opacity: ${(props) => (props.visible ? 1 : 0)};
  `,
  InputWidgetWrapper: styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
};

const FieldWrapper: React.FC<FieldWrapperProps & { error: FieldError }> = (props) => {
  const { error } = props;
  const hasError = Boolean(error);

  return (
    <div>
      {props.label && <s.Label>{props.label}</s.Label>}
      <s.InputWrapper>
        {props.children}
        {props.showInputWidget && (
          <s.InputWidgetWrapper>
            {props.inputWidget ? (
              props.inputWidget
            ) : (
              <s.ErrorIcon visible={hasError}>
                <ErrorIconSVG />
              </s.ErrorIcon>
            )}
          </s.InputWidgetWrapper>
        )}
      </s.InputWrapper>
      <s.Help>
        {error ? (
          <s.FieldErrorMessage visible={hasError}>{error}</s.FieldErrorMessage>
        ) : (
          props.help && <s.HelpMessage>{props.help}</s.HelpMessage>
        )}
      </s.Help>
    </div>
  );
};

export default FieldWrapper;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/FieldWrapper.tsx